"use strict";
/// Generated by terra, DO NOT MODIFY BY HAND.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgoraRhythmPlayerConfig = exports.RHYTHM_PLAYER_REASON = exports.RHYTHM_PLAYER_STATE_TYPE = void 0;
var RHYTHM_PLAYER_STATE_TYPE;
(function (RHYTHM_PLAYER_STATE_TYPE) {
    RHYTHM_PLAYER_STATE_TYPE[RHYTHM_PLAYER_STATE_TYPE["RHYTHM_PLAYER_STATE_IDLE"] = 810] = "RHYTHM_PLAYER_STATE_IDLE";
    RHYTHM_PLAYER_STATE_TYPE[RHYTHM_PLAYER_STATE_TYPE["RHYTHM_PLAYER_STATE_OPENING"] = 811] = "RHYTHM_PLAYER_STATE_OPENING";
    RHYTHM_PLAYER_STATE_TYPE[RHYTHM_PLAYER_STATE_TYPE["RHYTHM_PLAYER_STATE_DECODING"] = 812] = "RHYTHM_PLAYER_STATE_DECODING";
    RHYTHM_PLAYER_STATE_TYPE[RHYTHM_PLAYER_STATE_TYPE["RHYTHM_PLAYER_STATE_PLAYING"] = 813] = "RHYTHM_PLAYER_STATE_PLAYING";
    RHYTHM_PLAYER_STATE_TYPE[RHYTHM_PLAYER_STATE_TYPE["RHYTHM_PLAYER_STATE_FAILED"] = 814] = "RHYTHM_PLAYER_STATE_FAILED";
})(RHYTHM_PLAYER_STATE_TYPE || (exports.RHYTHM_PLAYER_STATE_TYPE = RHYTHM_PLAYER_STATE_TYPE = {}));
var RHYTHM_PLAYER_REASON;
(function (RHYTHM_PLAYER_REASON) {
    RHYTHM_PLAYER_REASON[RHYTHM_PLAYER_REASON["RHYTHM_PLAYER_REASON_OK"] = 0] = "RHYTHM_PLAYER_REASON_OK";
    RHYTHM_PLAYER_REASON[RHYTHM_PLAYER_REASON["RHYTHM_PLAYER_REASON_FAILED"] = 1] = "RHYTHM_PLAYER_REASON_FAILED";
    RHYTHM_PLAYER_REASON[RHYTHM_PLAYER_REASON["RHYTHM_PLAYER_REASON_CAN_NOT_OPEN"] = 801] = "RHYTHM_PLAYER_REASON_CAN_NOT_OPEN";
    RHYTHM_PLAYER_REASON[RHYTHM_PLAYER_REASON["RHYTHM_PLAYER_REASON_CAN_NOT_PLAY"] = 802] = "RHYTHM_PLAYER_REASON_CAN_NOT_PLAY";
    RHYTHM_PLAYER_REASON[RHYTHM_PLAYER_REASON["RHYTHM_PLAYER_REASON_FILE_OVER_DURATION_LIMIT"] = 803] = "RHYTHM_PLAYER_REASON_FILE_OVER_DURATION_LIMIT";
})(RHYTHM_PLAYER_REASON || (exports.RHYTHM_PLAYER_REASON = RHYTHM_PLAYER_REASON = {}));
class AgoraRhythmPlayerConfig {
}
exports.AgoraRhythmPlayerConfig = AgoraRhythmPlayerConfig;
